import { Edit, useTranslate } from 'react-admin'
import FormInput from './FormInput'

const ProductEdit = () => {
  const translate = useTranslate()

  return (
    <Edit title={translate("resources.products.name", {smart_count: 1})}>
      <FormInput />
    </Edit>
  )
}

export default ProductEdit